/** Formatea una cantidad con la unidad de medida configurada del artículo (ej. "14 UN"). */
export function formatCantidad(
  value: number | null | undefined,
  unidadMedida?: string | null,
  options?: { maximumFractionDigits?: number },
): string {
  if (value == null || Number.isNaN(value)) return '—';
  const numero = value.toLocaleString('es-AR', {
    maximumFractionDigits: options?.maximumFractionDigits ?? 2,
  });
  const um = resolveUnidadMedida(unidadMedida);
  return um ? `${numero} ${um}` : numero;
}

/** Normaliza la UM configurada del artículo (nunca usa el genérico "u."). */
export function resolveUnidadMedida(...candidatos: Array<string | null | undefined>): string {
  for (const c of candidatos) {
    const um = (c ?? '').trim();
    if (!um) continue;
    if (um.toLowerCase() === 'u' || um.toLowerCase() === 'u.') continue;
    return um;
  }
  return '';
}
